import {
  type DetailedHTMLProps,
  forwardRef,
  type SelectHTMLAttributes,
} from 'react';

import clsx from 'clsx';

import { SelectFilter } from './SelectFilter';

export const WrappedSelect = forwardRef<
  HTMLSelectElement,
  DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > & {
    label?: string;
    isOnModal?: boolean;
    innerClassName?: string;
    wrappedClassName?: string;
    error?: string | boolean;
    labelSize?: 'xs' | 'sm' | 'md';
    requiredMark?: boolean;
  }
>(function WrappedInput(
  { error, className, innerClassName, wrappedClassName, ...props },
  ref
) {
  return (
    <div className={className}>
      <SelectFilter
        {...props}
        ref={ref}
        innerClassName={clsx(
          innerClassName,
          error &&
            'dark:shadow-[inset_0px_0px_0px_1.5px_theme(colors.red.500)] shadow-[inset_0px_0px_0px_1.5px_theme(colors.red.300)]'
        )}
      />
      {typeof error === 'string' && (
        <p className="text-xs font-semibold text-red-500 dark:text-red-300">
          {error}
        </p>
      )}
    </div>
  );
});
